export const MuiDialogTitle = {
    styleOverrides: {
        root: {
            paddingTop: "10px",
            paddingBottom: "10px",
            paddingLeft: "32px",
            paddingRight: "22px",
            display: "flex",
            alignItems: "center",
            height: "52px"
        }
    }
};
//# sourceMappingURL=DialogTitle.js.map